import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { fetchEntityProfileInfo } from "../../api/entity";
import { colors } from "../../theme/palette";

import NavBar from "./NavBar";
import Footer from "./Footer";
import SideNav from "./SideNav";

const Layout = () => {
  useQuery({
    queryKey: ["userInfo"],
    queryFn: async () => {
      return await fetchEntityProfileInfo();
    },
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <NavBar />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          gap: "15px",
          maxWidth: "1140px",
          margin: "0 auto",
          background: colors.gray25,
          marginBottom: "35px",
        }}
      >
        <SideNav />
        <Box sx={{ width: "100%", maxWidth: "870px" }}>
          <Outlet />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
